

(function( ){
//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。

		$('.kuji-slider-pc').slick({
			centerMode: true,
			centerPadding: '0px',
			dots: true,
			infinite: false,
			adaptiveHeight: true,
			prevArrow:'<div class="slick-prev slider-arrow"></div>',
			nextArrow:'<div class="slick-next slider-arrow"></div>',
		});

		$('.about-slider-pc').slick({
			centerMode: true,
			centerPadding: '0px',
			dots: true,
			infinite: false,
			prevArrow:'<div class="slick-prev slider-arrow"></div>',
			nextArrow:'<div class="slick-next slider-arrow"></div>',
		});

		$('.pointflow-slider-sp').slick({
			centerMode: true,
			centerPadding: '0px',
			dots: true,
			infinite: false,
			adaptiveHeight: true,
			prevArrow:'<div class="slick-prev slider-arrow"></div>',
			nextArrow:'<div class="slick-next slider-arrow"></div>',
		});

		$('.kujiflow-slider-sp').slick({
			centerMode: true,
			centerPadding: '0px',
			dots: true,
			infinite: false,
			adaptiveHeight: true,
			prevArrow:'<div class="slick-prev slider-arrow"></div>',
			nextArrow:'<div class="slick-next slider-arrow"></div>',
		});
		$('.aboutflow-slider-sp').slick({
			centerMode: true,
			centerPadding: '0px',
			dots: true,
			infinite: false,
			adaptiveHeight: true,
			prevArrow:'<div class="slick-prev slider-arrow"></div>',
			nextArrow:'<div class="slick-next slider-arrow"></div>',
		});
		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
